import _ from 'lodash'

import {
  CREATE_STORY_MODAL_CLOSE,
  CREATE_STORY_MODAL_OPEN,
  CREATE_STORY_MODAL_CHANGE_FIELD,
  CREATE_STORY_MODAL_CHANGE_SAVING,
} from '_reducers/createStoryModal'
import { createWidget } from '_actions/widgets'
import { PUBLICATION_SCOPE_PRIVATE } from '_reducers/widgets'
import { associateWidgetToEvaluation } from '_actions/evaluations'
import { assignWidgetToMydEvaluation } from '_actions/myd_evaluations'
import { createRGAEvent } from 'utils/history'
import store from 'store'


export const onClose = () => {
  createRGAEvent('story-modal', 'Close modal to create story')
  return {
    type: CREATE_STORY_MODAL_CLOSE,
  }
}

export const onChangeField = (e, {name, value}) => {
  return {
    type: CREATE_STORY_MODAL_CHANGE_FIELD,
    name,
    value,
  }
}

export const onOpen = (fn=null, treeNodes=[]) => {
  createRGAEvent('story-modal', 'Open modal to create story')
  return {
    type: CREATE_STORY_MODAL_OPEN,
    onSubmit: fn,
    treeNodes,
  }
}

export const isSaving = isSaving => {
  return {
    type: CREATE_STORY_MODAL_CHANGE_SAVING,
    isSaving,
  }
}

export const submitCreateStoryModal = (createStoryModal, evaluationId=null, _type='criss') => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(isSaving(true))

    let data = {
      'attributes': {
        'name': createStoryModal.name,
        'type': 'story',
        'in_eportfolio': 'true',
        'config': {'children':[]},
        'thumbnail': '',
        'publication_scope': PUBLICATION_SCOPE_PRIVATE,
      },
      'type': 'widget',
    }

    const auth = store.getState().auth
    if (auth.isLogged && ! auth.user.isIndividual) {
      data = {
        ...data,
        'relationships': {
          'treenodes': {
            'data': [
              {
                'id': _.parseInt(createStoryModal.classgroup),
                'type': 'tree_node'
              }
            ]
          }
        }
      }
    }

    createWidget({data}).then(
      widget => {
        createRGAEvent('story-modal', `Story: ${widget.id} created by user: ${widget.createdBy}`)

        if (evaluationId !== null) {
          if (_type === 'criss') {
            let data = {
              'data': {
                'attributes': {
                  'evaluation_id': evaluationId,
                },
                'type': 'ict_evaluation_widget'
              }
            }

            associateWidgetToEvaluation(widget.id, data).then(
              res => {
                dispatch(isSaving(false))
                dispatch(onClose())
                resolve(widget)
              }
            ).catch(err => {
              dispatch(isSaving(false))
              dispatch(onClose())
              reject(err)
            })

          } else {
            assignWidgetToMydEvaluation(widget.id, evaluationId).then(
              res => {
                dispatch(isSaving(false))
                dispatch(onClose())
                resolve(widget)
              }
            ).catch(err => {
              dispatch(isSaving(false))
              dispatch(onClose())
              reject(err)
            })
          }

        } else {
          dispatch(isSaving(false))
          dispatch(onClose())
          resolve(widget)
        }
      }
    ).catch(err => {
      dispatch(isSaving(false))
      reject(err)
    })
  })
}
